import { getSessionUUIDLS } from "./LocalStorageIMJ";

export const decrypt = (valor: any) => {
    let key = getSessionUUIDLS();
    if (key === null || key === undefined || valor === null || valor === undefined) {
        return null;
    } else {
        return JSON.parse(
            (window as any)['CryptoJS'].TripleDES.decrypt(valor, key).toString(
                (window as any)['CryptoJS'].enc.Utf8
            )
        );
    }
};